import React from 'react';

const FacebookIcon = () => (
  <svg
    role="img"
    aria-label="Facebook"
    focusable="false"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22.597 5.213h-4.456c-.525 0-1.112.742-1.112 1.729v3.437H22.6v4.903h-5.57V30h-5.262V15.282H7v-4.9h4.768V7.5C11.768 3.362 14.454 0 18.14 0h4.456v5.213z" />
  </svg>
);

const FacebookBorderIcon = () => (
  <svg
    role="img"
    aria-label="Facebook"
    focusable="false"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.666 10.547V7.366c0-4.59 2.965-7.366 7.558-7.366a40.994 40.994 0 0 1 4.23.205L24 .26v5.716h-3.468c-1.657 0-2.071.466-2.071 1.897v2.674h5.437l-.859 6.313h-4.578V30h-6.795V16.86H7v-6.313h4.666zm7.558-8.424c-3.46 0-5.363 1.862-5.363 5.243v5.304H9.195v2.068h4.666v13.14h2.405V14.739h4.849l.281-2.07h-5.132V7.873c0-.716.053-1.205.276-1.788.535-1.397 1.831-2.23 3.99-2.23h1.273V2.198a44.599 44.599 0 0 0-2.58-.076z"
      fill="#000"
      fillRule="evenodd"
    />
  </svg>
);

const TwitterBorderIcon = () => (
  <svg
    role="img"
    aria-label="Twitter"
    focusable="false"
    width="30"
    height="30"
    viewBox="0 0 1200 1227"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_115_838)">
      <path
        d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_115_838">
        <rect width="1200" height="1227" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const TwitterIcon = () => TwitterBorderIcon;

const InstagramIcon = () => (
  <svg
    role="img"
    aria-label="Instagram"
    focusable="false"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#000" fillRule="evenodd">
      <path d="M23.66 30H6.34A6.34 6.34 0 0 1 0 23.66V6.34A6.34 6.34 0 0 1 6.34 0h17.32A6.34 6.34 0 0 1 30 6.34v17.32A6.34 6.34 0 0 1 23.66 30zM6.34 2A4.34 4.34 0 0 0 2 6.34v17.32A4.34 4.34 0 0 0 6.34 28h17.32A4.34 4.34 0 0 0 28 23.66V6.34A4.34 4.34 0 0 0 23.66 2H6.34z" />
      <path d="M15 22.759A7.759 7.759 0 1 1 22.759 15 7.769 7.769 0 0 1 15 22.759zm0-13.467A5.698 5.698 0 1 0 20.698 15 5.709 5.709 0 0 0 15 9.302v-.01zm8.286.018a2.586 2.586 0 1 1 2.576-2.596v.01a2.597 2.597 0 0 1-2.576 2.586zm0-4.168a1.572 1.572 0 1 0 1.562 1.582c0-.866-.696-1.57-1.562-1.582z" />
    </g>
  </svg>
);

const YoutubeIcon = () => (
  <svg
    role="img"
    aria-label="YouTube"
    focusable="false"
    width="37"
    height="30"
    viewBox="0 0 37 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#000" fillRule="evenodd">
      <path d="M6.261 4H30.74C34.197 4 37 6.845 37 10.355v13.29C37 27.155 34.197 30 30.739 30H6.26c-1.66 0-3.253-.67-4.427-1.861A6.404 6.404 0 0 1 0 23.645v-13.29C0 6.845 2.803 4 6.261 4zm0 1.907c-2.42 0-4.383 1.991-4.383 4.448v13.29c0 2.457 1.963 4.448 4.383 4.448H30.74c2.42 0 4.383-1.991 4.383-4.448v-13.29c0-2.457-1.963-4.448-4.383-4.448H6.26z" />
      <path d="M23.363 15.985c.391.196.637.59.637 1.02 0 .429-.246.822-.637 1.018l-3.656 1.843-4.005 2.01c-.362.18-.793.163-1.14-.043a1.141 1.141 0 0 1-.562-.971v-7.717c0-.399.212-.768.56-.976.347-.208.78-.225 1.143-.044l4.004 2.015 3.656 1.845z" />
    </g>
  </svg>
);

const MailIcon = () => (
  <svg
    role="presentation"
    focusable="false"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#000" fillRule="nonzero">
      <path d="M6.01 6.864c-1.482 0-1.88.078-2.285.298-.265.14-.482.36-.62.63-.215.413-.292.818-.292 2.327v8.762c0 1.509.076 1.914.293 2.327.146.278.345.48.619.63.405.22.804.298 2.284.298h17.982c1.48 0 1.88-.078 2.284-.298.274-.15.473-.352.62-.63.215-.413.293-.82.293-2.327V10.12c0-1.509-.077-1.914-.294-2.327a1.462 1.462 0 0 0-.619-.63c-.405-.22-.803-.298-2.284-.298H6.009zM6.01 4h17.98c2.091 0 2.848.221 3.612.638a4.299 4.299 0 0 1 1.772 1.804c.409.778.626 1.549.626 3.677v8.762c0 2.129-.218 2.9-.626 3.677a4.299 4.299 0 0 1-1.772 1.804c-.764.417-1.522.638-3.611.638H6.009c-2.09 0-2.847-.221-3.61-.638a4.299 4.299 0 0 1-1.773-1.804C.218 21.78 0 21.01 0 18.881V10.12c0-2.129.05-2.522.458-3.3.408-.777 1.312-1.365 2.075-1.781C3.297 4.62 3.92 4 6.01 4z" />
      <path d="M5.303 6.864l8.595 7.519a1.69 1.69 0 0 0 2.213 0l8.597-7.52h4.364L16.11 18.202a1.69 1.69 0 0 1-2.213 0L.938 6.864h4.365z" />
    </g>
  </svg>
);

const WhatsAppIcon = () => (
  <svg
    role="img"
    aria-label="WhatsApp"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 178.3 179.7"
  >
    <switch>
      <g>
        <path
          d="M178 80c-1.1-13.4-5.4-26.5-12.4-38-6.8-11.2-16.2-20.8-27.2-28C127.1 6.8 114.3 2.1 101 .6 97.6.2 94.2 0 90.8 0 72.7 0 54.9 5.6 40.2 16.1 25.8 26.3 14.7 40.7 8.6 57.3c-7 19.1-7.2 40.5-.3 59.7 1.9 5.3 4.3 10.4 7.2 15.2.4.6.4.5.2 1.1-.2.5-.4 1.1-.5 1.6-1.6 4.7-3.2 9.5-4.8 14.2-3.4 10-6.7 20-10.1 30-.1.2-.1.4-.2.6 5.5-1.8 11-3.5 16.6-5.3l26.2-8.4 3.9-1.2c.5-.2 1.3-.6 1.8-.6.2 0 .5.2.6.3.9.5 1.9 1 2.9 1.5 1.9.9 3.8 1.8 5.7 2.6 4 1.7 8.2 3 12.4 4 14.8 3.6 30.6 3.2 45.3-1 12.7-3.7 24.5-10.4 34.3-19.3 9.7-8.8 17.4-19.8 22.3-32 5.1-12.7 7.1-26.6 5.9-40.3zm-16.8 26.6c-2.7 10-7.6 19.3-14.2 27.3-6.6 7.9-14.8 14.5-24 19-9.5 4.7-20 7.2-30.6 7.5-13.2.3-26.4-3.1-37.8-9.7-.7-.4-1.4-.8-2.1-1.3-.4-.3-1.2-1-1.7-1.1-.1 0-.3.1-.4.1-.9.2-1.7.6-2.6.8-3.3 1-6.5 2.1-9.8 3.1-5.1 1.6-10.2 3.3-15.2 4.9.1-.2.1-.4.2-.6 2.6-7.8 5.3-15.7 7.9-23.5.2-.6.4-1.3.6-1.9.1-.3.3-.7.3-1 0-.3-.5-.7-.6-1-.6-.8-1.2-1.7-1.7-2.6-1.1-1.7-2.2-3.5-3.1-5.4-3.9-7.5-6.5-15.6-7.7-23.9-2-14.4.4-29.2 6.9-42.2 5.9-12 15.2-22.2 26.4-29.3 11.6-7.4 25.2-11.3 38.9-11.3 2.7 0 5.3.1 7.9.4 10.5 1.1 20.6 4.6 29.7 10 8.8 5.3 16.4 12.5 22.3 20.9 6 8.5 10 18.4 11.9 28.6 1.7 10.8 1.3 21.8-1.5 32.2zm-27.4 1.9c-1-.5-2-1.1-3-1.6-4-2.2-8-4.4-12.1-6.4-1.6-.8-3.8-2.2-5.6-1.3-1.1.5-1.8 1.8-2.5 2.7-.9 1.1-1.8 2.2-2.8 3.2-.9 1-1.8 2-2.7 2.9-.7.8-1.5 1.7-2.5 2-1.8.5-4-1.1-5.6-1.9-11.3-5.5-20.3-14.6-26.4-25.5-.6-1-1.2-2.1-1-3.3.3-1.3 1.6-2.2 2.4-3.1 1.2-1.3 2.5-2.6 3.6-4 .9-1.2 2-2.9 2-4.5s-1.1-3.5-1.7-5l-2.7-7.2-2.4-6.6c-.5-1.3-1.1-2.7-2.3-3.5-.7-.4-1.4-.4-2.1-.4-3 0-5.8-.9-8.6.6-1.7.9-3.2 2.5-4.5 4-1.5 1.7-2.8 3.6-3.8 5.6C44.1 66.3 48.4 79 55 88.6c1.1 1.6 2 3.2 3.1 4.8 2.4 3.5 4.9 6.9 7.7 10.2 3.7 4.4 7.8 8.4 12.3 12 5.2 4.2 10.9 7.3 17 9.9 4.9 2.1 9.8 4.2 15 5.4 2 .5 4.1.8 6.1.4 2.2-.4 4.5-.6 6.6-1.4 2.7-1 5.2-2.4 7.4-4.1 2.4-1.9 4-4 4.9-7 .5-1.7.9-3.4 1.1-5.1.1-1 .3-2.1 0-3.1-.3-1.1-1.5-1.6-2.4-2.1z"
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#231f20"
        />
      </g>
    </switch>
  </svg>
);

const CopyIcon = () => (
  <svg
    role="presentation"
    focusable="false"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.26 10.844a1.86 1.86 0 0 0 1.213-.544l3.96-3.96a1.867 1.867 0 1 0-2.64-2.64l-3.96 3.96a1.86 1.86 0 0 0-.543 1.213l.065-.065a1.393 1.393 0 1 1 1.97 1.97l-.066.066zm-2.272 2.271l-1.873 1.873a4.669 4.669 0 0 1-.835 5.465l-3.96 3.96a4.667 4.667 0 1 1-6.6-6.6l3.96-3.96a4.669 4.669 0 0 1 5.465-.835l1.873-1.873a4.669 4.669 0 0 1 .836-5.465l3.96-3.96a4.667 4.667 0 0 1 6.6 6.6l-3.96 3.96a4.669 4.669 0 0 1-5.466.835zm-4.144 4.144l-.084.083a1.393 1.393 0 0 1-1.969-1.97l.083-.082a1.86 1.86 0 0 0-1.214.544l-3.96 3.96a1.867 1.867 0 1 0 2.64 2.64l3.96-3.96a1.86 1.86 0 0 0 .544-1.215z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);

const LinkedInIcon = () => (
  <svg
    role="img"
    aria-label="LinkedIn"
    focusable="false"
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2414 11.3015C20.4208 11.3047 21.6439 11.6697 22.5792 12.5427C23.5281 13.4285 24.1115 14.7725 24.1119 16.5909C24.1119 16.5915 24.1119 16.5921 24.1119 16.5927L24.1469 23.3791C24.1477 23.5454 24.0822 23.7052 23.9649 23.8231C23.8476 23.941 23.6882 24.0073 23.5219 24.0073H19.9663C19.6211 24.0073 19.3413 23.7275 19.3413 23.3823V17.3959C19.3413 16.6037 19.1551 16.1584 18.9447 15.9177C18.7455 15.6897 18.4519 15.5622 18.0314 15.5622H17.93C17.496 15.6096 17.0966 15.8229 16.8158 16.1581C16.5292 16.5001 16.3891 16.9415 16.4259 17.3862C16.4273 17.4034 16.4281 17.4206 16.4281 17.4378V23.3823C16.4281 23.7275 16.1482 24.0073 15.8031 24.0073H12.3104C11.9652 24.0073 11.6854 23.7275 11.6854 23.3823V12.2059C11.6854 11.8607 11.9652 11.5809 12.3104 11.5809H15.5935C15.9386 11.5809 16.2185 11.8607 16.2185 12.2059V12.2514C16.4418 12.0797 16.6813 11.9281 16.9342 11.7992L17.2163 12.3524L16.9342 11.7992C17.6471 11.4357 18.4423 11.2642 19.2414 11.3015ZM19.1946 12.5507C18.6085 12.5213 18.0249 12.6462 17.502 12.9128C16.9792 13.1793 16.5353 13.5784 16.2149 14.0699C16.0995 14.2469 15.9026 14.3537 15.6913 14.3537H15.5935C15.2483 14.3537 14.9685 14.0738 14.9685 13.7287V12.8309H12.9354V22.7573H15.1781V17.4621C15.1219 16.6986 15.3655 15.9427 15.8577 15.3553C16.3558 14.7608 17.0684 14.3869 17.8406 14.3149C17.8599 14.3131 17.8792 14.3122 17.8986 14.3122H18.0314C18.7216 14.3122 19.3954 14.5339 19.886 15.0952C20.3654 15.6438 20.5913 16.4279 20.5913 17.3959V22.7573H22.8936L22.8619 16.5959L22.8619 16.5927C22.8619 15.0521 22.3766 14.0636 21.7262 13.4565C21.066 12.8402 20.1653 12.5515 19.2259 12.5515C19.2155 12.5515 19.2051 12.5512 19.1946 12.5507ZM6.09718 12.2059C6.09718 11.8607 6.37701 11.5809 6.72218 11.5809H10.2148C10.56 11.5809 10.8398 11.8607 10.8398 12.2059V23.3823C10.8398 23.7275 10.56 24.0073 10.2148 24.0073H6.72218C6.37701 24.0073 6.09718 23.7275 6.09718 23.3823V12.2059ZM7.34718 12.8309V22.7573H9.58982V12.8309H7.34718Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.48597 6.94604C7.70271 6.94604 7.06775 7.58101 7.06775 8.36427C7.06775 9.14753 7.70271 9.78249 8.48597 9.78249C9.26924 9.78249 9.9042 9.14753 9.9042 8.36427C9.9042 7.58101 9.26924 6.94604 8.48597 6.94604ZM5.81775 8.36427C5.81775 6.89065 7.01235 5.69604 8.48597 5.69604C9.95959 5.69604 11.1542 6.89065 11.1542 8.36427C11.1542 9.83789 9.95959 11.0325 8.48597 11.0325C7.01235 11.0325 5.81775 9.83789 5.81775 8.36427Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.8493 2.4949H25.3512C26.5938 2.4949 27.6012 3.50226 27.6012 4.7449V25.1124C27.6012 26.3551 26.5938 27.3624 25.3512 27.3624H4.8493C3.60666 27.3624 2.5993 26.3551 2.5993 25.1124V4.7449C2.5993 3.50226 3.60667 2.4949 4.8493 2.4949ZM4.8493 3.7449C4.29702 3.7449 3.8493 4.19262 3.8493 4.7449V25.1124C3.8493 25.6647 4.29702 26.1124 4.8493 26.1124H25.3512C25.9035 26.1124 26.3512 25.6647 26.3512 25.1124V4.7449C26.3512 4.19262 25.9035 3.7449 25.3512 3.7449H4.8493Z"
      fill="black"
    />
  </svg>
);

const ThreadsIcon = () => (
  <svg
    role="img"
    aria-label="Threads"
    focusable="false"
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.878 4.17663C15.882 4.23729 15.8818 4.2373 15.8816 4.23731L15.8873 4.23703C15.8953 4.23663 15.9097 4.23598 15.9301 4.23535C15.9708 4.23408 16.0353 4.23285 16.1206 4.23366C16.2916 4.23528 16.5449 4.24508 16.8581 4.27875C17.4867 4.34633 18.3427 4.50866 19.2526 4.88468C21.041 5.62377 23.094 7.20582 24.0354 10.7081C24.1609 11.1747 24.6409 11.4514 25.1076 11.3259C25.5743 11.2005 25.8509 10.7204 25.7255 10.2538C24.6264 6.16517 22.1509 4.18888 19.9209 3.26735C18.8217 2.81306 17.796 2.6195 17.0452 2.53878C16.6687 2.4983 16.358 2.48583 16.1373 2.48374C16.0268 2.48269 15.9385 2.48423 15.8755 2.4862C15.8555 2.48683 15.838 2.48749 15.8231 2.48813C15.8002 2.48716 15.771 2.48611 15.7358 2.48525C15.6517 2.4832 15.5333 2.48221 15.3856 2.48573C15.0906 2.49276 14.6764 2.51786 14.1822 2.58923C13.1972 2.73147 11.8728 3.0607 10.5403 3.81545C7.80776 5.36316 5.24455 8.58435 5.24455 15.0031C5.24455 21.4219 7.80776 24.6431 10.5403 26.1908C11.8728 26.9455 13.1972 27.2748 14.1822 27.417C14.6764 27.4884 15.0906 27.5135 15.3856 27.5205C15.5333 27.524 15.6517 27.523 15.7358 27.521C15.7711 27.5201 15.8005 27.5191 15.8235 27.5181L15.8587 27.5194C15.9113 27.5213 15.9849 27.5229 16.0772 27.5228C16.2617 27.5227 16.5218 27.5155 16.8396 27.4887C17.4736 27.4351 18.347 27.3022 19.3121 26.9833C21.2534 26.3419 23.5735 24.9419 25.0209 21.9551L25.0413 21.9131L25.0571 21.8691C25.5425 20.5164 25.7629 18.3974 24.5582 16.5827C23.8981 15.5885 22.8669 14.7685 21.3783 14.2229C21.3438 13.1356 21.124 12.1926 20.7503 11.3939C20.1371 10.0833 19.1355 9.22002 18.0022 8.77656C15.8033 7.91611 13.0595 8.64274 11.8385 10.6777C11.5899 11.092 11.7243 11.6295 12.1386 11.8782C12.553 12.1268 13.0905 11.9924 13.3391 11.578C14.059 10.3783 15.8436 9.81109 17.3645 10.4062C18.0912 10.6906 18.7473 11.2424 19.1652 12.1355C19.3699 12.573 19.5233 13.1059 19.5925 13.7456C18.6777 13.5777 17.6406 13.4875 16.4704 13.4875C16.4708 13.4876 16.4704 13.4938 16.4704 14.3625V13.4875L16.4688 13.4875L16.4668 13.4875L16.4618 13.4875L16.4475 13.4877C16.4361 13.4878 16.421 13.4881 16.4025 13.4886C16.3655 13.4897 16.3145 13.4916 16.2516 13.4954C16.1261 13.5028 15.9514 13.5175 15.7435 13.5464C15.3324 13.6035 14.7688 13.7193 14.1931 13.9591C13.6181 14.1987 12.9945 14.5775 12.5121 15.1805C12.0186 15.7973 11.7138 16.5986 11.7138 17.5971C11.7138 19.4594 13.524 21.0599 15.8235 21.0599C18.1275 21.0599 20.7092 19.4821 21.2151 16.4471C21.2362 16.3202 21.2553 16.1947 21.2724 16.0707C22.1783 16.4897 22.7482 17.0203 23.1002 17.5506C23.8794 18.7243 23.7898 20.1866 23.4252 21.2348C22.2292 23.671 20.3569 24.795 18.7631 25.3216C17.956 25.5883 17.2222 25.7001 16.6923 25.7449C16.4281 25.7672 16.2169 25.7727 16.0757 25.7728C16.0051 25.7729 15.9522 25.7716 15.9191 25.7705C15.9026 25.7699 15.891 25.7694 15.8846 25.769L15.8816 25.7689L15.8802 25.7688L15.8791 25.7687L15.8235 25.765L15.7679 25.7687L15.7663 25.7688L15.7553 25.7694C15.743 25.7699 15.7221 25.7708 15.6932 25.7715C15.6352 25.7729 15.545 25.7738 15.4274 25.771C15.1917 25.7654 14.8478 25.745 14.4323 25.685C13.5978 25.5644 12.4962 25.2874 11.4027 24.6681C9.2833 23.4676 6.99455 20.8694 6.99455 15.0031C6.99455 9.13685 9.2833 6.53862 11.4027 5.33816C12.4962 4.71882 13.5978 4.44178 14.4323 4.32126C14.8478 4.26125 15.1917 4.24085 15.4274 4.23523C15.545 4.23243 15.6352 4.23332 15.6932 4.23473C15.7221 4.23544 15.743 4.23628 15.7553 4.23684L15.767 4.23744L15.8239 4.24122L15.8797 4.23744L15.878 4.17663ZM16.4726 15.2375C17.7036 15.2376 18.7269 15.3441 19.5767 15.5247C19.5545 15.729 19.5253 15.9406 19.4889 16.1594C19.1439 18.2295 17.401 19.3099 15.8235 19.3099C14.2414 19.3099 13.4638 18.2613 13.4638 17.5971C13.4638 16.9783 13.6442 16.5667 13.8786 16.2737C14.1239 15.9671 14.4707 15.7393 14.8661 15.5745C15.2608 15.4101 15.6676 15.3237 15.9843 15.2797C16.1403 15.2581 16.2689 15.2474 16.3556 15.2423C16.3988 15.2397 16.4313 15.2385 16.4511 15.238L16.471 15.2375L16.4726 15.2375Z"
      fill="black"
    />
  </svg>
);

export {
  FacebookIcon,
  FacebookBorderIcon,
  TwitterIcon,
  TwitterBorderIcon,
  InstagramIcon,
  YoutubeIcon,
  MailIcon,
  WhatsAppIcon,
  CopyIcon,
  LinkedInIcon,
  ThreadsIcon
};
